import React, { useState } from 'react';
import { X, Compass, Copy, Check, Plus } from 'lucide-react';

const OpenInBrowserModal = ({ open, onClose }) => {
  const [copied, setCopied] = useState(false);
  if (!open) return null;

  const url = window.location.origin;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (_) {
      /* clipboard unavailable */
    }
  };

  return (
    <div
      data-testid="open-in-browser-modal"
      className="fixed inset-0 z-[2100] flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4 pointer-events-auto"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-4 border-b border-slate-100">
          <div className="flex items-center gap-2">
            <Compass size={16} className="text-emerald-600" />
            <h3 className="font-semibold text-slate-900 text-[15px]">Open in your browser to sign in</h3>
          </div>
          <button
            onClick={onClose}
            data-testid="open-in-browser-close"
            className="text-slate-400 hover:text-slate-700 p-1 rounded-lg hover:bg-slate-100"
          >
            <X size={16} />
          </button>
        </div>

        <div className="px-5 py-4 space-y-3">
          <p className="text-[13px] text-slate-600 leading-relaxed">
            Google sign-in is blocked inside in-app browsers (Instagram, X, LinkedIn, etc.).
            To sign in, open this site in <strong>Safari</strong> or <strong>Chrome</strong>:
            tap the <strong>•••</strong> menu and choose <strong>“Open in browser”</strong>.
          </p>

          <div className="flex items-center gap-2">
            <div className="flex-1 min-w-0 text-[12.5px] text-slate-700 bg-slate-50 border border-slate-200 rounded-lg px-3 py-2 truncate">
              {url}
            </div>
            <button
              onClick={copyLink}
              data-testid="open-in-browser-copy"
              className="inline-flex items-center gap-1.5 bg-slate-900 hover:bg-slate-800 text-white text-[12.5px] font-medium px-3 py-2 rounded-lg transition-colors flex-shrink-0"
            >
              {copied ? <Check size={13} strokeWidth={3} /> : <Copy size={13} />}
              {copied ? 'Copied' : 'Copy link'}
            </button>
          </div>

          <div className="flex items-start gap-2 text-[12.5px] text-emerald-800 bg-emerald-50 border border-emerald-200 rounded-lg px-3 py-2.5">
            <Plus size={14} className="mt-0.5 flex-shrink-0" strokeWidth={2.5} />
            <span>
              Good news — you <strong>don’t need to sign in to submit a startup</strong>.
              Just close this and tap “Submit your startup”.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OpenInBrowserModal;
